import React, { useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import {
    Popover,
    Box,
    Typography,
    Stack,
    Collapse
} from '@mui/material';
import { Circle, ExpandMore } from '@mui/icons-material';
import { LegendIconButton } from '../style/map_components';
import { CHRONOLOGY_LEVEL_LABEL } from '../const/color';
import { setChronologyLevelColor } from '../func/color';

// 警報基準相当とクロノロジー（被害情報）の2つの凡例をまとめて表示する（PREINのmap_sr_chronology_legend_iconと同じ作り）
const MapSrChronologyLegendIcon = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [legendOpen, setLegendOpen] = useState(false);
    const [srOpen, setSrOpen] = useState(false);
    const [chronologyOpen, setChronologyOpen] = useState(false);

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e) => {
        setAnchorEl(null);
    };

    // アイコンのスタイル
    const iconStyle = { width: '21px', height: '21px' }

    // 警報基準相当の凡例（map_sediment_legend_icon と同じ内容）
    const SrLegendItems = [
        { color: '#534f59', label: '特別警報相当' },
        { color: '#b92ec9', label: '危険警報相当' },
        { color: '#ff2600', label: '警報相当' },
        { color: '#faf600', label: '注意報相当' },
        { color: '#0092d1', label: '平常' }
    ];

    // マップのクロノロジーの点（setChronologyLevelColor）と同じ色・名称
    const ChronologyLegendItems = Object.values(CHRONOLOGY_LEVEL_LABEL).map(label => ({
        label,
        color: setChronologyLevelColor(label)
    }));

    const ExpandableHeader = ({ label, expanded, toggle, sx = {} }) => (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                userSelect: 'none',
                mb: 0.5,
                ...sx
            }}
            onClick={toggle}
        >
            <ExpandMore
                sx={{
                    transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)',
                    transition: 'transform 0.2s',
                    fontSize: 16,
                    mr: 0.5
                }}
            />
            <Typography sx={{ fontSize: '0.75rem' }}>{label}</Typography>
        </Box>
    );

    return (
        <>
            <LegendIconButton
                onClick={handleClick}>
                <InfoIcon sx={iconStyle} />
            </LegendIconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Box sx={{ p: 1, maxHeight: 300, overflowY: 'auto' }}>
                    {/* タイトル部：クリックで開閉 */}
                    <ExpandableHeader
                        label="凡例"
                        expanded={legendOpen}
                        toggle={() => setLegendOpen(!legendOpen)}
                    />
                    <Collapse in={legendOpen}>
                        <Box sx={{ pl: 2 }}>
                            {/* サブセクション1：警報基準相当 */}
                            <ExpandableHeader
                                label={props.label}
                                expanded={srOpen}
                                toggle={() => setSrOpen(!srOpen)}
                                sx={{ mb: 0.25 }}
                            />
                            <Collapse in={srOpen}>
                                <Stack direction="column" spacing={0.5} pl={1}>
                                    {SrLegendItems.map((item, index) => (
                                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Circle sx={{ color: item.color, fontSize: "10px" }} />
                                            <Typography sx={{ fontSize: "10px", pl: 1, minWidth: 60 }}>{item.label}</Typography>
                                        </Box>
                                    ))}
                                </Stack>
                            </Collapse>
                        </Box>
                        <Box sx={{ pt: 1, pl: 2 }}>
                            {/* サブセクション2：クロノロジー（被害情報） */}
                            <ExpandableHeader
                                label="被害情報"
                                expanded={chronologyOpen}
                                toggle={() => setChronologyOpen(!chronologyOpen)}
                                sx={{ mb: 0.25 }}
                            />
                            <Collapse in={chronologyOpen}>
                                <Stack direction="column" spacing={0.5} pl={1}>
                                    {ChronologyLegendItems.map((item, index) => (
                                        <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Circle sx={{ color: item.color, fontSize: "10px" }} />
                                            <Typography sx={{ fontSize: "10px", pl: 1, minWidth: 70 }}>{item.label}</Typography>
                                        </Box>
                                    ))}
                                </Stack>
                            </Collapse>
                        </Box>
                    </Collapse>
                </Box>
            </Popover>
        </>
    );
};

export default MapSrChronologyLegendIcon;
